/**
 * icon-picker-icons — registro de ícones (sem JSX).
 *
 * Mora em arquivo `.ts` puro (sem JSX) pra preservar
 * react-refresh/only-export-components em consumers `.tsx`.
 * Helper `renderIconByName` (que retorna JSX) vive em `icon-by-name.tsx`.
 */

import {
  Activity, AlertCircle, AlertTriangle, ArrowRight, Award, Bell,
  Bookmark, Briefcase, Calendar, Camera, Check, CheckCircle, CheckSquare,
  Clock, Cloud, Coffee, Cpu, CreditCard, Download, Edit3, Eye, FileText,
  Flag, Folder, Gift, Globe, Hash, Heart, Home, Image, Inbox, Key,
  Layers, Link, List, Loader, Lock, Mail, MapPin, MessageCircle,
  MessageSquare, Mic, Minus, MoreHorizontal, Package, Paperclip, Pause,
  Phone, PhoneCall, Play, Plus, RefreshCw, Save, Search, Send, Settings,
  Share2, Shield, ShoppingCart, Star, Tag, Target, ThumbsUp, Trash2,
  TrendingUp, Truck, Upload, User, UserCheck, Users, Video, Wrench,
  X, Zap,
  type LucideIcon,
} from 'lucide-react';

export const ICON_MAP: Record<string, LucideIcon> = {
  Activity, AlertCircle, AlertTriangle, ArrowRight, Award, Bell,
  Bookmark, Briefcase, Calendar, Camera, Check, CheckCircle, CheckSquare,
  Clock, Cloud, Coffee, Cpu, CreditCard, Download, Edit3, Eye, FileText,
  Flag, Folder, Gift, Globe, Hash, Heart, Home, Image, Inbox, Key,
  Layers, Link, List, Loader, Lock, Mail, MapPin, MessageCircle,
  MessageSquare, Mic, Minus, MoreHorizontal, Package, Paperclip, Pause,
  Phone, PhoneCall, Play, Plus, RefreshCw, Save, Search, Send, Settings,
  Share2, Shield, ShoppingCart, Star, Tag, Target, ThumbsUp, Trash2,
  TrendingUp, Truck, Upload, User, UserCheck, Users, Video, Wrench,
  X, Zap,
};

export const ICON_PICKER_NAMES = Object.keys(ICON_MAP).sort();
